import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { APIService } from '../api.service';
import { CommonService } from '../services/common.service';
import { DataService } from '../services/data.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { from, Subject } from 'rxjs';

@Component({
  selector: 'app-financial-yearcount',
  templateUrl: './financial-yearcount.component.html',
  styleUrls: ['./financial-yearcount.component.scss']
})
export class FinancialYearcountComponent implements OnInit {

  @Input() mdlRef: any;
  @Input() LedgerRecordData: any;

  changingValue: Subject<boolean> = new Subject();
  changingHeadValue: Subject<boolean> = new Subject();
  closeResult: any;

  //apiService: any;
  ERP_Agn: any;
  acctStartDT: Date = new Date();
  financialYears: any = [];
  selectedFY: any;
  //selectedDate : any;
  checkFinancialYear: any = [];
  modalReference: any;
  //modalService: any;
  fromDate: Date = new Date("2021-Apr-01");
  toDate: Date = new Date("2022-Mar-31");

  constructor(private apiService: APIService, private modalService: NgbModal, private commonService: CommonService, private dataser: DataService) {

    this.dataser.LedgerRecordData.subscribe((value: any) => {
    });
  }

  ngOnInit(): void {
    let accountDate = this.apiService.getCookie("AccountsDates");
    if (accountDate) {
      let accountsDate = JSON.parse(accountDate);
      if (accountsDate.length > 0) {
        if (accountsDate[0].selectedFy == 'Other') {
          this.fromDate = new Date(accountsDate[0].fdt);
          this.toDate = new Date(accountsDate[0].tdt);
        } else {
          this.financialYears = this.commonService.checkFinancialYear(new Date("2021"), new Date());
          this.selectedFY = this.financialYears[this.financialYears.length - 1].FY;

          localStorage.setItem("periods", this.selectedFY);
          let currentDate = new Date();
          this.fn_Set_FinancialYear(currentDate);
         
          // let accountDate: Array<any> = [{
          //   fdt: new Date(result.fromDT).customFormat('#DD#-#MMM#-#YYYY#'),
          //   tdt: new Date(result.toDT).customFormat('#DD#-#MMM#-#YYYY#'),
          //   selectedFy: 'Other'
          // }];
          // this.apiService.setCookie("AccountsDates", JSON.stringify(accountDate));
          // this.changingValue.next($event);
          // this.changingHeadValue.next($event);
        }
      }

    }

    // this.financialYears = this.commonService.checkFinancialYear(new Date("2021"), new Date());
    // this.selectedFY = this.financialYears[this.financialYears.length - 1].FY;

    // localStorage.setItem("periods", this.selectedFY);

    // let currentDate = new Date();
    // this.fn_Set_FinancialYear(currentDate);

  }

  chnageFY() {
    if (this.selectedFY != 'Other') {
      let selectedYear;
      selectedYear = this.selectedFY.split("-")[0] + "";
      let toDate = (Number(selectedYear) + 1) + "/03/31";
      // this.selectedDate = toDate;
      this.fn_Set_FinancialYear(toDate);
      let obj = {
        fromDT: this.fromDate,
        toDT: this.toDate,
      }
      this.mdlRef.close(obj);
    }
    else {
    }
  }

  CloseModel() {
    this.mdlRef.close();
  }

  serach() {
   
    let obj = {
      fromDT: this.fromDate,
      toDT: this.toDate,
    }
    // this.chnageDate();
    this.mdlRef.close(obj);
   
  }

  fn_Set_FinancialYear(ToDT: any) {
    var Date1 = new Date(ToDT);
    var Year;
    var IsPrevios = 0;
    if (Date1.getMonth() < 3) {
      Year = Date1.getFullYear() - 1
      IsPrevios = 1;
    } else {
      Year = Date1.getFullYear() + 1
      IsPrevios = 0;
    }
    if (IsPrevios == 1) {
      this.fromDate = new Date(Year + "/04/01");
      this.toDate = new Date(Date1.getFullYear() + "/03/31");
    }
    else if (IsPrevios == 0) {
      this.fromDate = new Date(Date1.getFullYear() + "/04/01");
      this.toDate = new Date(Year + "/03/31");
    }
  }

  chnageDate(){
    if (this.fromDate == null && this.toDate == null) {
      alert('Please select valid date.')
      return;
    }
  }

}


